import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/add_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-6d7bd020"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "brands__card"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "sub__title"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common__point active__point mg-r--10"
}, null, -1));

const _hoisted_5 = {
  class: "common__text active__text"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "brand__logo"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "line"
};
const _hoisted_10 = {
  class: "text--center"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "add__img",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("footer", {
  class: "text--center"
}, "Add", -1));

const _hoisted_13 = [_hoisted_11, _hoisted_12];
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {
      type: Array,
      default: []
    },
    currentSelectKey: {
      type: String,
      default: 'id'
    },
    currentSelectValue: {
      type: [String, Number],
      default: -1
    }
  },
  emits: ['handleAdd', 'handleCommand', 'itemClick'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;

    const handleAdd = () => {
      emits('handleAdd');
    };

    const handleCommand = (item, type) => {
      emits('handleCommand', {
        type,
        data: item
      });
    };

    const stopClick = () => {}; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '16px',
        fontWeight: 'bold'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    const itemClick = (item, index) => {
      emits('itemClick', item, index);
    };

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(item[__props.currentSelectKey] === __props.currentSelectValue ? 'is-select' : ''),
          onClick: _withModifiers($event => itemClick(item, index), ["stop"])
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: _normalizeClass(['common__title', item.status === 1 ? 'product__active' : item.status === 2 ? 'product__terminal' : 'no__product__active'])
        }, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(item.status === 1 ? _ctx.$t('运行') : item.status === 2 ? _ctx.$t('终端审核') : _ctx.$t('停运')), 1)], 2), _createVNode(_component_el_dropdown, {
          "show-timeout": 100,
          onClick: _withModifiers(stopClick, ["stop"]),
          onCommand: $event => handleCommand(item, $event)
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: "edit"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('编辑')), 1)]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "delete"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("i", {
            onClick: _withModifiers(stopClick, ["stop"]),
            class: "iconfont icon-gengduo fs--26 more__setting"
          }, null, 8, _hoisted_6)]),
          _: 2
        }, 1032, ["onClick", "onCommand"])]), _createElementVNode("div", _hoisted_7, [item.logo ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_8)) : _createCommentVNode("", true)]), item.logo ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("footer", _hoisted_10, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "item-name"
          }, _toDisplayString(item.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"])])], 10, _hoisted_2);
      }), 256)), _createElementVNode("li", {
        class: "add__item",
        onClick: handleAdd
      }, _hoisted_13)]);
    };
  }

});